import * as analytics from "analytics";
import { TypedEventEmitter } from "shared/TypedEventEmitter";

export const events = new TypedEventEmitter<{
  new: [achievement: string, value?: boolean];
}>();
let user;

/**
 * Initialize walkthrough module.
 *
 * @param injectedUser - The user model to be used by the walkthrough module. This is injected
 *                       instead of imported for use in the browser extension.
 */
export const init = (injectedUser) => {
  user = injectedUser;
  window.addEventListener("appinstalled", () => {
    setAchievement("standalone", true);
  });
};

export const hasAchievement = (achievement) => {
  const acheivements = user.state.value.acheivements;
  return acheivements && acheivements.indexOf(achievement) > -1;
};

export const setAchievement = async (achievement, value?: boolean) => {
  const acheivements = [...(user.state.value.acheivements ?? [])];
  const index = acheivements.indexOf(achievement);
  let changed = false;

  if (index > -1 && typeof value !== "undefined" && value === false) {
    acheivements.splice(index, 1);
    changed = true;
  }
  if (index === -1 && (typeof value === "undefined" || value === true)) {
    acheivements.push(achievement);
    changed = true;
  }
  if (changed) {
    await user.save(
      {
        acheivements: acheivements,
      },
      {
        patch: true,
        success: function () {
          analytics.trackEventWithProperties("gotAchievement", {
            achievement,
            value,
            // A more consistent way to populate local user properties would be better than this
            // ad-hoc approach
            "Learning Language": user.state.value.currentLearningLanguage,
            "From Language": user.state.value.firstLanguage,
          });
        },
        error: function () {},
      }
    );
    events.trigger("new", achievement, value);
  }
};
